import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PreQualificationDeclinedPage() {
    return (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx("h1", { className: "first-title", children: "Pre-qualification" }), _jsx("p", { className: "first-subtitle", children: "Thank you for your interest." }), _jsx("p", { children: "We were unable to pre-qualify you. " })] }) }));
}
export default PreQualificationDeclinedPage;
